import React from 'react';
import { IonButton, IonLoading } from '@ionic/react';
import { AuthenticationParams } from '../repositories/AuthenticationRepository';
import { login } from '../store/actions/authentication';
import { connect } from 'react-redux';
import './LoginForm.scss';

type Inputs = {
  email: string;
  password: string;
};

type RegistrationFormProps = {
  onSubmit: Function;
  registerRouterLink?: string;
  forgotPasswordLink?: string;
};

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  login: (params: AuthenticationParams) => dispatch(login(params))
});

const LoginForm: React.FC<
  ReturnType<typeof mapDispatchToProps> & RegistrationFormProps
> = ({ registerRouterLink = '/dashboard/register', onSubmit }) => {
  return (
    <div className="ion-padding-vertical">
      <IonLoading isOpen={false} />

      <div className="ion-text-center ion-padding-horizontal">
        <IonButton onClick={() => onSubmit()} expand="block">
          Je me connecte
        </IonButton>

        <hr />

        <IonButton
          fill="outline"
          routerLink={registerRouterLink}
          routerDirection="root"
          expand="block"
        >
          Je n'ai pas de compte
        </IonButton>
      </div>
    </div>
  );
};

export default connect(null, mapDispatchToProps)(LoginForm);
